import { IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface InletPressureModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the edit-profile.
   */
}

export const InletPressureModal: React.FC<InletPressureModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={formatMessage(JobMessages.inletPressureHeading)}
      onClose={onClose}
      primaryButton={{ label: formatMessage(JobMessages.gotItButton), onClick: onClose }}
    >
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.overviewHeading)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.inletPressureOverviewDescription)}</DqText>
      </IonRow>
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.insightsHeading)}</DqText>
      </IonRow>
      <ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.inletPressureInsightDescriptionOne)}</DqText>
        </li>

        <li>
          <DqText variant="body">{formatMessage(JobMessages.inletPressureInsightDescriptionTwo)}</DqText>
        </li>

        <li>
          <DqText variant="body">{formatMessage(JobMessages.inletPressureInsightDescriptionThree)}</DqText>
        </li>
      </ul>
    </AppModal>
  );
};

export default InletPressureModal;
